import { createStore, applyMiddleware, compose } from "redux";
import { syncHistoryWithStore } from "react-router-redux";
import { browserHistory } from "react-router";
import { persistStore, autoRehydrate } from "redux-persist";
import thunk from "redux-thunk";

import rootReducer from "./reducers/index";

const defaultState = {
    authentication: {},
    globalmessages: []
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
    return new Promise((resolve, reject) => {
        try {
            const store = createStore(rootReducer, defaultState, composeEnhancers(applyMiddleware(thunk), autoRehydrate({ log: false })));

            persistStore(
                store,
                {
                    blacklist: ["routing", "globalmessages", "OverviewState"]
                },
                () => {
                    const history = syncHistoryWithStore(browserHistory, store);
                    resolve({ store, history });
                }
            );
        } catch (e) {
            reject(e);
        }
    });
}
